<template>
  <div class="menu-container">
    <div class="menu-item" v-for="item in menuConfig" :key="item.key + item.type">
      <!-- 项目文件 -->
      <div v-if="item.type === 1">
        <div
          class="menu-item-title item radio-item"
          :class="{
            'item-enble-click': !item.disabled,
            'item-selected': selectType === 1 && projectFileSelectedList.length === 0
          }"
          @click="clickItem(item)"
        >
          <span class="text text-gap item-content">{{ item.text }}</span>
          <a-tooltip v-if="item.tips">
            <a-icon type="question-circle" />
            <template slot="title">
              <span>{{ item.tips }}</span>
            </template>
          </a-tooltip>
          <span class="text-gap text-orang" v-if="item.count > 0">({{ item.count }})</span>
        </div>
        <div v-for="detail in item.children" :key="detail.key" style="display: flex; flex-direction: column">
          <div
            @click="clickItem(detail)"
            class="item checkbox-item"
            :class="{
              'item-disable-click': !!detail.disabled,
              'item-enble-click': !detail.disabled,
              'item-selected': projectFileSelectedList.find(_ => _.fileTypeId === detail.key) && !detail.children
            }"
          >
            <a-icon :type="detail.icon" :class="detail.count === -1 ? 'grey-title' : 'text-orang'"></a-icon>
            <span class="text-gap item-content" :class="detail.count === -1 ? 'grey-title' : ''" v-if="detail.text && detail.text.length < 7">{{
              detail.text
            }}</span>
            <a-tooltip v-else>
              <span class="text-gap item-content" :class="detail.count === -1 ? 'grey-title' : ''">{{ detail.text }}</span>
              <template slot="title">
                <span>{{ detail.text }}</span>
              </template>
            </a-tooltip>

            <span class="text-gap text-orang" v-if="detail.count >= 0">({{ detail.count }})</span>
            <a-tooltip v-if="detail.tips">
              <a-icon type="question-circle" />
              <template slot="title">
                <span>{{ detail.tips }}</span>
              </template>
            </a-tooltip>
          </div>
          <!-- 财务文件展示子类型 -->
          <div v-if="detail.children">
            <div
              v-for="subdetail in detail.children"
              @click="clickItem(detail, subdetail)"
              :key="subdetail.key"
              style="margin-left: 24px"
              class="item checkbox-item"
              :class="{
                'item-disable-click': !!detail.disabled,
                'item-enble-click': !detail.disabled,
                'item-selected': projectFileSelectedList.find(_ => _.fileTypeId === detail.key && _.fileSubtypeId === subdetail.key)
              }"
            >
              <a-icon class="text-orang" :type="detail.icon"></a-icon>
              <span class="text-gap item-content" v-if="subdetail.text && subdetail.text.length < 7">{{ subdetail.text }}</span>
              <span class="text-gap text-orang" v-if="subdetail.count >= 0">({{ subdetail.count }})</span>
            </div>
          </div>
        </div>
        <a-button type="link" v-if="showMore && isFold" @click="showMoreDocument">查看更多文档类型</a-button>
        <a-button type="link" v-if="showMore && !isFold" @click="showMoreDocument">收起</a-button>
      </div>
      <!-- 项目文件以外的(飞书群/portfolio作业) -->
      <div v-else>
        <a-divider style="margin: 15px 0"></a-divider>
        <div
          class="menu-item-title item radio-item"
          :class="{ 'item-enble-click': !item.disabled, 'item-selected': `${item.type}-${item.key}` === selectKey }"
          @click="clickItem(item)"
        >
          <!--          <span class="text text-gap item-content">{{ item.text }}</span>-->
          <span class="text text-gap item-content">
            {{ item.text }}
            <!-- Portfolio 作业的子筛选项下拉 -->
            <template v-if="item.type === documentTypeMap.portfolioFile">
              <a-dropdown @click.stop>
                <a class="ant-dropdown-link" @click.stop.prevent>
                  {{ item.currentTabLabel }}
                  <a-icon type="down" />
                </a>
                <template #overlay>
                  <a-menu>
                    <a-menu-item v-for="tab in item.childrenTabs" :key="tab.value" @click="$emit('portfolioTabChange', tab.value)">
                      {{ tab.label }}
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </template>
          </span>

          <a-tooltip v-if="item.tips">
            <a-icon type="question-circle" />
            <template slot="title">
              <span>{{ item.tips }}</span>
            </template>
          </a-tooltip>
          <span class="text-gap text-orang" v-if="item.count > 0">({{ item.count }})</span>
        </div>
        <div
          v-for="detail in item.children"
          :key="detail.key"
          @click="clickItem(detail)"
          class="sub-item item radio-item"
          :class="{
            'item-disable-click': !!detail.disabled,
            'item-enble-click': !detail.disabled,
            'item-selected': `${detail.type}-${detail.key}` === selectKey && detail.key !== 28
          }"
        >
          <a-icon class="text-orang" :type="detail.icon"></a-icon>
          <span class="text-gap item-content" v-if="detail.text && detail.text.length < 7">{{ detail.text }}</span>
          <a-tooltip v-else>
            <span class="text-gap item-content">{{ detail.text }}</span>
            <template slot="title">
              <span>{{ detail.text }}</span>
            </template>
          </a-tooltip>

          <span class="text-gap text-orang" v-if="detail.count >= 0">({{ detail.count }})</span>
          <a-tooltip v-if="detail.tips">
            <a-icon type="question-circle" />
            <template slot="title">
              <span>{{ detail.tips }}</span>
            </template>
          </a-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    menuConfig: {
      type: Array,
      default() {
        return [
          {
            text: '项目文档-全部',
            count: 10,
            type: 1,
            key: 1,
            disabled: true,
            tips: 'xxxxx',
            children: [
              {
                icon: 'file',
                text: '项目文档-全部',
                count: 10,
                type: 1,
                key: 12,
                disabled: true
              }
            ]
          }
        ];
      }
    },
    projectFileSelectedList: {
      type: Array,
      default: () => []
    },
    showMore: {
      type: Boolean,
      default: false
    },
    documentTypeMap: {
      type: Object,
      required: true
    }
  },
  data() {
    let selectKey;
    if (this.menuConfig && this.menuConfig.length > 0) {
      let item = this.menuConfig[0];
      selectKey = `${item.type}-${item.key}`;
    }
    return {
      selectKey: selectKey,
      selectType: 1,
      isFold: true
    };
  },
  methods: {
    clickItem(item, subitem = null) {
      // item.type 1-项目文件 2-飞书群 3-portfolio
      if (item.disabled) return;
      this.selectKey = `${item.type}-${item.key}`;
      this.selectType = item.type;
      this.$emit('clickItem', item, subitem);
    },

    showMoreDocument() {
      this.$emit('showMoreDocument', this.isFold);
      this.isFold = !this.isFold;
    }
  }
};
</script>
<style lang="less" scoped>
.menu-container {
  border-right: solid 1px #e8e8e8;
  width: 200px;
}
.menu-item-title {
  color: rgba(0, 0, 0, 0.65);
  cursor: default;
  .text {
    font-weight: bolder;
    margin-right: 5px;
  }
}
.grey-title {
  color: #afacac;
}
.text-gap {
  margin: 0 5px;
}

.item {
  display: flex;
  align-items: center;
  transition: all 0.2s ease-in-out;
}
.item-content {
  flex: base 0 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.checkbox-item {
  border-radius: 4px;
  width: fit-content;
  max-width: 180px;
  padding: 4px 4px 4px 8px;
  margin: 4px 8px 4px 12px;
}
.radio-item {
  padding: 8px 3px;
}
.sub-item {
  padding-left: 20px;
}
.item-enble-click {
  cursor: pointer;
  &:hover {
    color: #1890ff;
    // background-color: #e6f7ff;
  }
  &:active {
    opacity: 0.8;
  }
  .text-orang {
    color: #faad14;
  }
}
.item-selected {
  color: #1890ff;
  background-color: #e6f7ff;
  span {
    font-weight: bold;
  }
}
.item-disable-click {
  color: rgba(0, 0, 0, 0.25);
  background: none;
  border-color: transparent;
  cursor: not-allowed;
}
</style>
